export default "__VITE_ASSET__qgKquvVb__"